// import React, { useEffect, useState } from 'react';
// import './PriceRangeSlider.scss';

// const PriceRangeSlider = ({ minPrice, maxPrice, onChange, currency }) => {
//     const [values, setValues] = useState({ min: minPrice || 0, max: maxPrice || 5000 });
//     const [isDragging, setIsDragging] = useState(null);

//     const handleSliderChange = (type, value) => {
//         let newValues = { ...values };
        
//         if (type === 'min') {
//             newValues.min = Math.min(Math.max(0, parseInt(value)), values.max - 1);
//         } else {
//             newValues.max = Math.max(Math.min(5000, parseInt(value)), values.min + 1);
//         }

//         setValues(newValues);
//         onChange(newValues);
//     };

//     const handleInputChange = (type, value) => {
//         let numValue = parseInt(value) || 0;
//         let newValues = { ...values };

//         if (type === 'min') {
//             newValues.min = Math.min(Math.max(0, numValue), values.max - 1);
//         } else {
//             newValues.max = Math.max(Math.min(5000, numValue), values.min + 1);
//         }

//         setValues(newValues);
//         onChange(newValues);
//     };

//     const getPercentage = (value) => {
//         return ((value - 0) / (5000 - 0)) * 100;
//     };

//     return (
//         <div className="price-range-slider">
//             <div className="slider-container">
//                 <div className="slider-track">
//                     <div 
//                         className="slider-range" 
//                         style={{
//                             left: `${getPercentage(values.min)}%`,
//                             width: `${getPercentage(values.max) - getPercentage(values.min)}%`
//                         }}
//                     ></div>
//                 </div>
//                 <input
//                     type="range"
//                     min="0"
//                     max="5000"
//                     step="1"
//                     value={values.min}
//                     onChange={(e) => handleSliderChange('min', e.target.value)}
//                     className="thumb thumb--left"
//                     style={{ zIndex: isDragging === 'min' ? 3 : 1 }}
//                     onMouseDown={() => setIsDragging('min')}
//                     onMouseUp={() => setIsDragging(null)}
//                     onTouchStart={() => setIsDragging('min')}
//                     onTouchEnd={() => setIsDragging(null)}
//                 />
//                 <input
//                     type="range"
//                     min="0"
//                     max="5000"
//                     step="1"
//                     value={values.max}
//                     onChange={(e) => handleSliderChange('max', e.target.value)}
//                     className="thumb thumb--right"
//                     style={{ zIndex: isDragging === 'max' ? 3 : 1 }}
//                     onMouseDown={() => setIsDragging('max')}
//                     onMouseUp={() => setIsDragging(null)}
//                     onTouchStart={() => setIsDragging('max')}
//                     onTouchEnd={() => setIsDragging(null)}
//                 />
//             </div>
//             <div className="price-inputs">
//                 <div className="input-group">
//                     {/* <span className="currency-symbol">{currency.symbol}</span> */}
//                     <label>Min</label>
//                     <input
//                         type="number"
//                         value={values.min}
//                         onChange={(e) => handleInputChange('min', e.target.value)}
//                         placeholder="Min"
//                     />
//                 </div>
//                 <span className="separator">-</span>
//                 <div className="input-group">
//                     {/* <span className="currency-symbol">{currency.symbol}</span> */}
//                     <label>Max</label>
//                     <input
//                         type="number"
//                         value={values.max}
//                         onChange={(e) => handleInputChange('max', e.target.value)}
//                         placeholder="Max"
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PriceRangeSlider;

import React, { useEffect, useState, useRef } from 'react';
import './PriceRangeSlider.scss';

const PriceRangeSlider = ({ minPrice, maxPrice, onChange, currency, resetTrigger }) => {
    // 1. Initialize local state for smooth UI updates
    const [values, setValues] = useState({ 
        min: Number(minPrice) || 0, 
        max: Number(maxPrice) || 5000 
    });
    
    const [isDragging, setIsDragging] = useState(null);
    
    // 2. Create a Ref to hold the debounce timer
    const debounceTimer = useRef(null);

    // 3. Sync local state with Parent props (only if NOT dragging)
    // This ensures that if you reset filters from the parent, the slider updates.
    useEffect(() => {
        if (!isDragging) {
            setValues({ 
                min: Number(minPrice) || 0, 
                max: Number(maxPrice) || 5000 
            });
        }
    }, [minPrice, maxPrice, resetTrigger]);

    // 4. Handle internal slider changes (Visual Only)
    const handleSliderChange = (type, value) => {
        let newValues = { ...values };
        let val = parseInt(value);

        if (type === 'min') {
            newValues.min = Math.min(Math.max(0, val), values.max - 1);
        } else {
            newValues.max = Math.max(Math.min(5000, val), values.min + 1);
        }

        setValues(newValues); // Update UI immediately
        triggerDebouncedChange(newValues); // Schedule parent update
    };

    const handleInputChange = (type, value) => {
        let numValue = parseInt(value) || 0;
        let newValues = { ...values };

        if (type === 'min') {
            newValues.min = Math.min(Math.max(0, numValue), values.max - 1);
        } else {
            newValues.max = Math.max(Math.min(5000, numValue), values.min + 1);
        }

        setValues(newValues);
        triggerDebouncedChange(newValues);
    };

    // 5. The Debounce Logic
    // This waits 500ms after the last movement before telling the parent to filter
    const triggerDebouncedChange = (newValues) => {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        debounceTimer.current = setTimeout(() => {
            onChange(newValues);
        }, 500); 
    };

    const getPercentage = (value) => {
        return ((value - 0) / (5000 - 0)) * 100;
    };

    return (
        <div className="price-range-slider">
            <div className="slider-container">
                <div className="slider-track">
                    <div 
                        className="slider-range" 
                        style={{
                            left: `${getPercentage(values.min)}%`,
                            width: `${getPercentage(values.max) - getPercentage(values.min)}%`
                        }}
                    ></div>
                </div>
                <input
                    type="range"
                    min="0"
                    max="5000"
                    step="1"
                    value={values.min}
                    onChange={(e) => handleSliderChange('min', e.target.value)}
                    className="thumb thumb--left"
                    style={{ zIndex: isDragging === 'min' ? 3 : 1 }}
                    onMouseDown={() => setIsDragging('min')}
                    onMouseUp={() => setIsDragging(null)}
                    onTouchStart={() => setIsDragging('min')}
                    onTouchEnd={() => setIsDragging(null)}
                />
                <input
                    type="range"
                    min="0"
                    max="5000"
                    step="1"
                    value={values.max}
                    onChange={(e) => handleSliderChange('max', e.target.value)}
                    className="thumb thumb--right"
                    style={{ zIndex: isDragging === 'max' ? 3 : 1 }}
                    onMouseDown={() => setIsDragging('max')}
                    onMouseUp={() => setIsDragging(null)}
                    onTouchStart={() => setIsDragging('max')}
                    onTouchEnd={() => setIsDragging(null)}
                />
            </div>
            <div className="price-inputs">
                <div className="input-group">
                    {/* Optional: Add currency symbol here if needed */}
                    {/* <span className="currency-symbol">{currency?.symbol}</span> */}
                    <label>Min</label>
                    <input
                        type="number"
                        value={values.min}
                        onChange={(e) => handleInputChange('min', e.target.value)}
                        placeholder="Min"
                    />
                </div>
                <span className="separator">-</span>
                <div className="input-group">
                    <label>Max</label>
                    <input
                        type="number"
                        value={values.max}
                        onChange={(e) => handleInputChange('max', e.target.value)}
                        placeholder="Max"
                    />
                </div>
            </div>
        </div>
    );
};

export default PriceRangeSlider;